import { render, staticRenderFns } from "./StoreSelector.vue?vue&type=template&id=5bc64f40&"
import script from "./StoreSelector.vue?vue&type=script&lang=js&"
export * from "./StoreSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports